
export enum PickupShipmetActionCd {
	ADD = 'Add',
	DELETE = 'Delete',
	MOVE = 'Move',
	NO_ACTION = 'NoAction',
	OPERATIONAL_MOVE = 'OperationalMove',
	UPDATE = 'Update'}
